<script setup>
import { ref, defineProps } from 'vue';

// Functions
import getNewsCategories from '../functions/getNewsCategories.js';
import getNewsList from '../functions/getNewsList.js';
import dateFormat from '../functions/dateFormat.js';
import getCatData from '../functions/getCatData.js';

const props = defineProps({
    rootPath: {
        type: String,
        default: ''
    },
    pageData: {
        type: Object,
        default: {}
    },
});

// 定数
const perPage = 3; //1ページの記事数
const taxonomy = 'news_cat'; //タクソノミー名

// リアクティブデータを定義
const categories = ref([]); //カテゴリ一覧
const posts = ref([]); //記事一覧

// カテゴリを取得
categories.value = await getNewsCategories(props.rootPath, taxonomy);

// 記事情報を取得
const postsData = await getNewsList(props.rootPath, perPage, taxonomy);
posts.value = posts.value.concat(postsData.postsList);
</script>

<template>
<div class="news__area wow animate__fadeIn" v-if="posts.length">
    <h2 class="sec-tit is-top-news">
        <span class="sec-tit__en">{{ props.pageData.name }}</span>
        <span class="sec-tit__ja">{{ props.pageData.nameJa }}</span>
    </h2>
    <dl class="news__list">
    <div class="news__row" v-for="val in posts" :key="val.id">
        <dt class="news-data">
            <span class="news-data__date">{{ dateFormat(val.date, 'YYYY.MM.DD') }}</span>
            <a :href="`/news/?category=${getCatData(val[taxonomy][0], 'slug', categories)}`" class="news-data__cat">
                {{ getCatData(val[taxonomy][0], 'name', categories) }}
            </a>
        </dt>
        <dd class="news__txt">
            <a :href="val.link" v-html="val.title.rendered"></a>
        </dd>
    </div>
</dl>
    <div class="news__link-area">
        <a :href="props.pageData.url" class="link">MORE<span class="arrow is-b"></span></a>
    </div>
</div>
</template>